export function buildSdtTrialUrl(
  baseFullTrialUrl: string,
  isUnrecognizedDevice: boolean,
  appInstanceId: string | null,
  appSessionId: string | null,
): string {
  const queryParams: string[] = [];

  if (isUnrecognizedDevice) {
    queryParams.push('from_app=true');
  }

  if (appInstanceId) {
    queryParams.push(`pg_ga4_app_instance_id=${encodeURIComponent(appInstanceId)}`);
  }

  if (appSessionId) {
    queryParams.push(`pg_ga4_app_session_id=${encodeURIComponent(appSessionId)}`);
  }

  const query = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  return `${baseFullTrialUrl}${query}`;
}
